import { render, staticRenderFns } from "./colleagueOrder.vue?vue&type=template&id=24ae3344&scoped=true&"
import script from "./colleagueOrder.vue?vue&type=script&lang=js&"
export * from "./colleagueOrder.vue?vue&type=script&lang=js&"
import style0 from "./colleagueOrder.vue?vue&type=style&index=0&id=24ae3344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae3344",
  null
  
)

export default component.exports